export default "__VITE_ASSET__Dr_2ODTU__"